import React from 'react';
import { Typography } from '@mui/material';

interface MessageContent {
  header?: { text?: string };
  body?: { text?: string };
  footer?: { text?: string };
  action?: { thumbnail_product_retailer_id?: string };
  text?: string;
}

interface MessageProps {
  message: { content?: MessageContent };
}

const MessageCatalog: React.FC<MessageProps> = ({ message }) => {
  const content = message?.content || {};
  const header = content?.header?.text;
  const body = content?.body?.text;
  const footer = content?.footer?.text;
  const productId = content?.action?.thumbnail_product_retailer_id;
  const fallbackText = content?.text; // simple catalog text

  return (
    <>
      <Typography variant="h6" fontWeight="bold" gutterBottom>
        Catalog
      </Typography>

      {header && (
        <Typography variant="subtitle1" gutterBottom>
          {header}
        </Typography>
      )}

      {body && (
        <Typography variant="body2" sx={{ my: 1 }}>
          {body}
        </Typography>
      )}

      {!body && !header && fallbackText && (
        <Typography variant="body2" sx={{ mt: 1 }}>
          {fallbackText}
        </Typography>
      )}

      {footer && (
        <Typography variant="caption" color="textSecondary" display="block" sx={{ mt: 1 }}>
          {footer}
        </Typography>
      )}

      {productId && (
        <Typography variant="body2" sx={{ mt: 1 }}>
          Product ID: {productId}
        </Typography>
      )}
    </>
  );
};

export default MessageCatalog;
